import { COLORS_CHART } from "constants/DashboardContanst";
import PropTypes from "prop-types";
import React from "react";
import ReactApexChart from "react-apexcharts";
const dountchart = ({ series = [], labels = [] }) => {
  const dataLabel = [
    "Hóa đơn giá trị gia tăng",
    "Hóa đơn bán hàng",
    "Tem, vé thuộc loại hóa đơn GTGT",
  ];
  const options = {
    labels: dataLabel,
    colors: COLORS_CHART,
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      verticalAlign: "middle",
      floating: false,
      fontSize: "20px",
      offsetX: 0,
      offsetY: -10,
    },
    responsive: [
      {
        breakpoint: 100,
        options: {
          chart: {
            height: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <ReactApexChart
      options={options}
      series={Object.values(series)}
      type="donut"
      height="400"
    />
  );
};

dountchart.propTypes = {
  series: PropTypes.any,
  labels: PropTypes.any,
};

export default dountchart;
